import { story } from "@/mocks/manga";

export default function Hero() {
  return (
    <section id="home" className="relative flex min-h-[640px] w-full items-center overflow-hidden md:min-h-[680px]">
      <img
        src="https://readdy.ai/api/search-image?query=warm%20romantic%20anime%20illustration%20of%20a%20cheerful%20girl%20and%20a%20cool%20boy%20under%20blooming%20cherry%20trees%20at%20golden%20hour%2C%20soft%20coral%20and%20peach%20color%20palette%2C%20clean%20dreamy%20background%2C%20high%20detail%2C%20comfortable%20whitespace%20for%20text%20overlay&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
        alt="恋爱辅助器漫画暖色插画背景"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/60 via-primary-900/40 to-background-50" aria-hidden="true"></div>

      <div className="relative mx-auto w-full max-w-7xl px-4 pb-16 pt-32 md:px-6 md:pb-24">
        <p className="mb-5 inline-flex items-center gap-2 rounded-full border border-white/30 bg-white/10 px-4 py-1.5 text-xs font-medium tracking-wide text-white backdrop-blur">
          <i className="ri-heart-2-fill text-primary-300" aria-hidden="true"></i>
          校园恋爱 · 欢喜冤家 · 双向奔赴
        </p>

        <h1 className="font-heading text-4xl font-black leading-tight text-white md:text-6xl">
          恋爱辅助器
          <span className="mt-3 block font-display text-2xl font-medium text-primary-200 md:text-4xl">
            男主女主 · CP感情线 · 角色关系全整理
          </span>
        </h1>

        <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/90 md:text-lg">
          元气少女 × 高冷学霸 × 一台会吐槽的恋爱辅助器。这里汇总
          <strong className="font-semibold text-primary-200"> 恋爱辅助器漫画角色 </strong>
          与<strong className="font-semibold text-primary-200"> 男主女主人物介绍 </strong>，
          梳理角色关系与CP走向，聚焦感情线发展。点开即得完整人物图谱与CP互动梳理。
        </p>

        <div className="mt-9 flex flex-col gap-3 sm:flex-row">
          <a
            href="#characters"
            className="whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-center text-sm font-semibold text-white transition-transform hover:-translate-y-0.5 hover:bg-primary-600"
          >
            查看角色介绍
          </a>
          <a
            href="#romance"
            className="whitespace-nowrap rounded-full border border-white/40 bg-white/10 px-7 py-3.5 text-center text-sm font-semibold text-white backdrop-blur transition-colors hover:bg-white/20"
          >
            <i className="ri-time-line mr-1.5" aria-hidden="true"></i>
            浏览CP感情线
          </a>
        </div>

        <dl className="mt-14 grid max-w-3xl grid-cols-2 gap-x-6 gap-y-6 sm:grid-cols-4">
          {story.stat.map((s) => (
            <div key={s.label} className="border-l-2 border-primary-300/60 pl-4">
              <dt className="text-xs text-white/75">{s.label}</dt>
              <dd className="mt-1 font-heading text-xl font-bold text-white md:text-2xl">{s.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}